import { canViewAppDashboard, canViewDashboard } from './dashboard-access'

const routerDriver: any = {
  init() {
    if (!this.plugins.router) {
      return 'The Vue Router plugin has not been set.'
    }
  },
  beforeEach(routerBeforeEach, transitionEach, setTransitions, getAuthMeta) {
    const auth = this
    this.plugins.router.beforeEach((to, from, next) => {
      setTransitions(to)
      routerBeforeEach.call(auth, () => {
        transitionEach.call(auth, to, getAuthMeta(to), (redirect) => {
          // 認証・ユーザー情報の取得が完了してから判定する。直リンクでも画面を描画しない。
          if (!redirect) {
            const access = to.meta.dashboardAccess
            if (
              (access === 'viewer' && !canViewDashboard(auth.user())) ||
              (access === 'admin' && !canViewAppDashboard(auth.user()))
            )
              return next({ name: 'Home', replace: true })
          }
          next(redirect || undefined)
        })
      })
    })
  },
  routerReplace(data) {
    return this.plugins.router.replace(data).catch(() => undefined)
  },
  routerGo(data) {
    return this.plugins.router.push(data).catch(() => undefined)
  }
}

export default routerDriver
